export default "__VITE_ASSET__09072d59__"